<template>
  <a-card :bordered="false">
    <div>
      <div class="operation-wrap" style="display: flex;flex-wrap: wrap">
        <div>
          <a-input style="width: 400px" allowClear v-model="searchForm.data.keywords"/>
        </div>
        <a-button type="primary" @click="addI18NDetail">
          {{ $t('ADD') || '添加' }}
        </a-button>
      </div>
      <a-table
        row-key="i18nCode"
        :data-source="table.data
        .filter(data => !searchForm.data.keywords || data.values.toLowerCase()
        .includes(searchForm.data.keywords.toLowerCase()))"
        style="width: 100%">
        <a-table-column
          data-index="i18nCode"
          title="字符编码">
        </a-table-column>
        <a-table-column
          :key="item.id"
          v-for="(item) in language.data"
          :title="item.name">
          <template slot="header">
            <span :class="item.icon"></span> {{ item.name }}
          </template>
          <template slot-scope="text,record">
            {{ record[item.code] }}
          </template>
        </a-table-column>
        <a-table-column
          data-index="date"
          :title="$t('OPERATION')||'操作'">
          <template slot-scope="text, record">
            <a-button type="link" @click="editI18NDetail(record.i18nCode)">
              {{ $t('EDIT') || '编辑' }}
            </a-button>
            <a-button type="link" @click="deleteI18NDetail(record.i18nCode)">
              {{ $t('REMOVE') || '删除' }}
            </a-button>
          </template>
        </a-table-column>
      </a-table>
    </div>
    <a-modal :footer="null"
             title="翻译编辑"
             v-model="form.visible">
      <i18NDetail-edit
        v-if="form.visible"
        :i18n-code="form.data.i18nCode"
        :on-cancel-handler="closeForm"
        :on-submit-handler="closeForm">
      </i18NDetail-edit>
    </a-modal>
  </a-card>
</template>

<script>
import {
  _queryI18NDetails,
  _deleteI18NDetail,
} from '@/api/sys/i18NDetailApi';
import {
  _queryLanguages,
} from '@/api/sys/languageApi';
import I18NDetailEdit from './I18NDetailEdit.vue';

async function getLanguages() {
  this.table.loading = true;
  const { content } = await _queryLanguages({});
  this.language.data = content.filter(x => x.isActive === 'YES');
  this.table.loading = false;
}

async function getI18NDetailList() {
  this.table.loading = true;
  const content = await _queryI18NDetails({});
  const i18nMap = new Map();
  content.forEach((x) => {
    if (!i18nMap.has(x.i18nCode)) {
      i18nMap.set(x.i18nCode, {
        i18nCode: x.i18nCode,
        values: '',
      });
    }
    const obj = i18nMap.get(x.i18nCode);
    obj[x.languageCode] = x.value;
    obj.values += x.value;
  });
  this.table.data = [...i18nMap.values()];
  this.table.loading = false;
}

function addI18NDetail() {
  this.form.data.i18nCode = null;
  this.form.visible = true;
}

function editI18NDetail(code) {
  this.form.data.i18nCode = code;
  this.form.visible = true;
}

function closeForm() {
  this.form.data.i18nCode = null;
  this.form.visible = false;
  this.getI18NDetailList();
}

async function deleteI18NDetail(i18nCode) {
  this.$confirm({
    title: this.$t('CONFIRM_REMOVE'),
    content: '',
    onOk: async () => {
      const result = await _deleteI18NDetail(i18nCode);
      if (result) {
        this.$message.success(this.$t('REMOVE_SUCCESS'));
        this.getI18NDetailList();
      }
    },
  });
}

export default {
  name: 'I18NDetailList',
  components: { I18NDetailEdit },
  data() {
    return {
      searchForm: {
        data: {
          keywords: '',
        },
      },
      form: {
        data: {
          id: null,
          i18nCode: null,
        },
        visible: false,
      },
      language: {
        data: [],
      },
      table: {
        loading: false,
        head: {},
        data: [],
        query: {
          page: 1,
          size: 100,
          total: 0,
        },
        sort: {
          prop: 'updateAt',
          order: 'descending',
        },
      },
    };
  },
  methods: {
    getI18NDetailList,
    deleteI18NDetail,
    editI18NDetail,
    addI18NDetail,
    closeForm,
    getLanguages,
  },
  created() {
    this.getLanguages();
    this.getI18NDetailList();
  },
};
</script>

<style scoped>

</style>
